import conn from "@/store/utils/connection";
import resulter from "@/store/utils/resulter";
import api from "../apiEndPoint";

export default {
    getRiwayatPaket: ({ commit, getters }, { idMesin }) => {
        let query = {
            offset: getters.pagePaket.offset,
            limit: getters.pagePaket.limit,
        };
        commit("setFetching", true);
        commit("setResponse", {});
        conn.get(`${api.getRiwayatPaket}/${idMesin}`, query)
            .then((res) => {
                let { code, data, status, msg } = res.data;
                if (code === 200 && status) {
                    conn.setQueryString(query);
                    commit("setListPaket", data);
                    commit("setEndPaket", data.array[data.array.length - 1]);
                    commit("setNextPagePaket", data);
                    commit("setResponse", resulter.successResult(msg));
                } else {
                    commit("setResponse", resulter.errorResult(msg));
                }
                commit("setFetching", false);
                commit("setLoadMore", false);
            })
            .catch((e) => {
                commit("setFetching", false);
                commit("setLoadMore", false);
                commit("setResponse", resulter.errorResult(e));
            });
    },
};
